import { render, staticRenderFns } from "./ChartletItem.vue?vue&type=template&id=ea977bce&scoped=true&"
import script from "./ChartletItem.vue?vue&type=script&lang=js&"
export * from "./ChartletItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartletItem.vue?vue&type=style&index=0&id=ea977bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea977bce",
  null
  
)

export default component.exports